type Coords = { lat: string, lng: string } | { lat: number, lng: number }

// The Radius of the earth in Meter
const EARTH_RADIUS_IN_METER = 6371000

// Convert degrees to radians
function toRadians(degrees: number) {
  return degrees * (Math.PI / 180)
}

export default (point: Coords, center: Coords, radiusInMeters: number) => {
  const pointCoords = {
    lat: parseNumberOrStringToNumber(point.lat),
    lng: parseNumberOrStringToNumber(point.lng),
  }
  const centerCoords = {
    lat: parseNumberOrStringToNumber(center.lat),
    lng: parseNumberOrStringToNumber(center.lng),
  }

  // Compute the differences in latitude and longitude in radians
  const dLat = toRadians(pointCoords.lat - centerCoords.lat)
  const dLon = toRadians(pointCoords.lng - centerCoords.lng)

  // Convert latitudes to radians
  const lat1 = toRadians(centerCoords.lat)
  const lat2 = toRadians(pointCoords.lat)

  // Apply the Haversine formula to calculate the great-circle distance
  // See: https://en.wikipedia.org/wiki/Haversine_formula
  const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.sin(dLon / 2) * Math.sin(dLon / 2) * Math.cos(lat1) * Math.cos(lat2)
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))

  // Compute the distance in meters and check if it is inside the given radius
  const distance = EARTH_RADIUS_IN_METER * c
  return distance <= radiusInMeters
}
